import { render, staticRenderFns } from "./TheErrorStatus.vue?vue&type=template&id=a5727744&scoped=true&"
import script from "./TheErrorStatus.vue?vue&type=script&lang=js&"
export * from "./TheErrorStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5727744",
  null
  
)

export default component.exports